export type SubjectRestoredAction = {
	type: 'SUBJECT_RESTORED';
	payload: { subjectId: number };
};

export default (subjectId: number): SubjectRestoredAction => ({
	type: 'SUBJECT_RESTORED',
	payload: { subjectId },
});
